import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createActionButtonDriver = function (wrapper) {
    var classNames = ".action-button";
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, classNames, 'action-button');
    return {
        click: function () { return baseDriver.click(); },
        getText: function () { return baseDriver.getText(); },
        isDisabled: function () { return baseDriver.elem.hasAttribute('disabled'); },
        loaderVisible: function () { return false; }
    };
};
//# sourceMappingURL=action-button.driver.js.map